import { render, staticRenderFns } from "./StatusOrderPill.vue?vue&type=template&id=ef23650e&"
import script from "./StatusOrderPill.vue?vue&type=script&lang=js&"
export * from "./StatusOrderPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports